
if (isNullOrUndefined(sumo)) {
    throw ('GoogleMapControl.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}
/**
 *
 *
 * mEnrolleesControls.PlaybackControl = mEnrolleesControls.EnrolleesMap.getPlaybackController('Visits', {
        'speedControls': {
            'keyProperty': 'TrackTypeId',
            'values': [
            {
                'value': 1,
                'speedMultiplier': 1
            }, {
                'value': 2,
                'speedMultiplier': 1
            }, {
                'value': 3,
                'speedMultiplier': 1
            }, {
                'value': 'undefined',
                'speedMultiplier': 4
            }]
        },
        'bookmarks':{
            'filterByMethod': function (aSumoData) {
                return !isNullOrUndefined(aSumoData)? bookmarkDataFormatter(aSumoData).HasEvents:false;
            },
            'formatMethod': bookmarkDataFormatter
        }
    }
 *
 * @param {*} aKeyLayer
 * @param {*} aSupportLayers
 * @param {*} aOptions
 */
sumo.maps.Playback = function (aKeyLayer, aSupportLayers, aOptions) {
    "use strict";

    sumo.maps.Playback.prototype.baseClass.call(this);

    var mThis = this,
        STOPPED = 0,
        PLAYING = 1,
        PAUSED = 2,
        Previous = 3,
        mItemsToShow = 10,
        mKeyLayer = aKeyLayer,
        mTrackIcon = "Images/Maps/Trackpoints/MapMarker.png",
        mSupportLayers = aSupportLayers,
        mSupportLayersIsVisible = [],
        mOverlayIndex = -1,
        mOverlayCount = mKeyLayer.overlays().length,
        mSpeedDivider = 1,
        mIntervalId = null,
        mInitialInterval = 750,
        mInterval = mInitialInterval,
        mState = STOPPED,
        mSliding = 10,
        mDirection = 1,
        mOverlaysVisible = [],
        mMinOverlayIndexRange,
        mMaxOverlayIndexRange,
        mPreviousOverlay,
        mSpeedProperty = null,
        mBookmarksData = {},
        mBookmarksHashMap = new Map(),
        mBookmarkPercentage = 0,
        mBookmarksDateRange = null,
        mBookmarksAutoPause=false,
        mSliderId = "uBookmarks",
        mBookmarkClass = 'ui-slider-bookmark',
        mSpeedMultipliers = [],
        mCurrentMultiplier = 1,
        mIdentityProperty = 'identity',
        mSupportHash = [],
        mSupportDisplay = [],
        mCurrentPoint = null,
        mOverlaysPlayed = 0,
        mIsActive = true;

    function setState(aState) {
        var lShownOverlay = mKeyLayer.showOverlay(mOverlayIndex);

        mState = aState;
        FixStateDisplay();
        
        if (!mThis.isNothing(lShownOverlay)) {
            mThis.trigger('statechange', { 'state': mState, 'currentPoint': lShownOverlay.sumoData });
        } else {
            mThis.trigger('statechange', { 'state': mState, 'currentPoint': null });
        }
    }

    function FixStateDisplay() {
        var lShownOverlay = null,
            lImage;

        if (mOverlayIndex >= 0) {

            lShownOverlay = mKeyLayer.showOverlay(mOverlayIndex);
            lImage = mKeyLayer.getMarkerOverlay(mOverlayIndex);
            if (isNullOrUndefined(lShownOverlay)) {
                lShownOverlay = mKeyLayer.showOverlay(mOverlayIndex - 1);
                lImage = mKeyLayer.getMarkerOverlay(mOverlayIndex - 1);
            }
            lShownOverlay.icon.url = lImage;
        }
        else if(mState == STOPPED && mDirection == -1 && mOverlayIndex == -1) {
            lShownOverlay = mKeyLayer.showOverlay(0);
            lShownOverlay.icon.url = mKeyLayer.getMarkerOverlay(0);
        }
    }

    function reInitialize() {
        mOverlayIndex = -1; // YES, minus one
        mSpeedDivider = 1;
        mOverlayCount = mKeyLayer.overlays().length;
        mInterval = mInitialInterval;
        setState(STOPPED);
        mDirection = 1; // 1 forward, -1 reverse

        var i = 0;

        mSupportLayersIsVisible = [];
        for (i = 0; i < mSupportLayers.length; i++) {
            mSupportLayersIsVisible.push(mSupportLayers[i].isVisible());
        }
    }

    function stopTimer() {
        if (mIntervalId !== null) {
            window.clearInterval(mIntervalId);
            mIntervalId = null;
        }
    }

    function iterateShowOverlay() {
        var lLayer = null,
            lOldDataSource,
            lNewDataSource,
            lName,
            lKey,
            i;
        for (i = 0; i < mSupportLayers.length; i++) {
            if (mSupportLayersIsVisible[i]) {
                lLayer = mSupportLayers[i];
                lName = lLayer.name();
                lOldDataSource = mSupportDisplay[lName];
                lNewDataSource = mSupportHash[lName][mOverlayIndex];
                for (lKey in lOldDataSource) {
                    if (lOldDataSource.hasOwnProperty(lKey) && lNewDataSource.indexOf(lOldDataSource[lKey]) === -1) {
                        lLayer.hideOverlay(lOldDataSource[lKey]);
                    }
                }
                mSupportDisplay[lName] = [];
                for (lKey in lNewDataSource) {
                    if (lNewDataSource.hasOwnProperty(lKey)) {
                        lLayer.showOverlay(lKey);
                        mSupportDisplay[lName].push(lKey);
                    }
                }
            }
        }
    }

    function iterateHideOverlay() {
        var lLayer = null,
            i,
            lHideIndex = mOverlayIndex - (mDirection * mItemsToShow);
        for (i = 0; i < mSupportLayers.length; i++) {
            if (mSupportLayersIsVisible[i]) {
                lLayer = mSupportLayers[i];
                if (lLayer.renderType() !== 'linesegment') {
                    lLayer.hideOverlay(lHideIndex);
                } else if (mDirection === 1 && mKeyLayer.overlayIsVisible(lHideIndex)) {
                    lLayer.hideOverlay(lHideIndex);
                } else if (mDirection === -1 && mKeyLayer.overlayIsVisible(lHideIndex)) {
                    lLayer.hideOverlay(lHideIndex - 1);
                }
            }
        }
    }

    function iterateResetVisiblity() {
        var i;
        for (i = 0; i < mSupportLayers.length; i++) {
            mSupportLayers[i].isVisible(mSupportLayersIsVisible[i]);
        }
    }

    function iterateSupportLayers(aFunction, aParameter) {
        var lLayer = null,
            i;
        for (i = 0; i < mSupportLayers.length; i++) {
            lLayer = mSupportLayers[i];
            lLayer[aFunction](aParameter);
        }
    }

    function window_OnTimer() {
        mKeyLayer.show();
        iterateResetVisiblity();
        mThis.trigger('completed', null);
    }

    function correctOverlayVisibility() {
        var lOverlays = mKeyLayer.overlays(),
            lIsValid = false,
            lItem,
            i;

        for (i = 0; i < mOverlaysVisible.length; i++) {
            lItem = mOverlaysVisible[i];
            lIsValid = false;

            if (!mThis.isNothing(lItem)) {
                lItem = lOverlays[lItem];
                if (!mThis.isNothing(lItem) && !lItem.visible) {
                    lIsValid = true;
                    mOverlaysVisible.splice(i, 1); // if not visible, remove from visible list
                }
            }
            if (!lIsValid) {
                mMinOverlayIndexRange = mOverlayIndex - mItemsToShow + 1;
                mMaxOverlayIndexRange = mOverlayIndex + 1;

                if (mOverlaysVisible[i] < mMinOverlayIndexRange || mOverlaysVisible[i] > mMaxOverlayIndexRange) {
                    mKeyLayer.hideOverlay(mOverlaysVisible[i]);
                }
            }
        }
    }

    function window_OnInterval() {
        mOverlayIndex += mDirection;
        updateOverlays();
    }

    function startTimer() {
        if (mIntervalId === null) {
            mIntervalId = window.setInterval(window_OnInterval, mInterval);
        }
    }
    function updateOverlays() {
        var lShownOverlay = null,
            lPreviousOverlay = null,
            lMultiplier;

        if ((mDirection === 1 && mOverlayIndex < mOverlayCount) ||
            (mDirection === -1 && mOverlayIndex >= 0)) {
            // playback is not complete, so continue
            
            // leading icon user story 796 iteration4/cdcr
            if (mOverlayIndex > 0 && mDirection == 1) {
                lPreviousOverlay = mKeyLayer.showOverlay(mOverlayIndex - 1);
                lPreviousOverlay.icon.url =  mKeyLayer.getMarkerOverlay(mOverlayIndex - 1);
            }
            else if (mDirection == -1) {
                lPreviousOverlay = mKeyLayer.hideOverlay(mOverlayIndex + 1);
                lPreviousOverlay.icon.url = mKeyLayer.getMarkerOverlay(mOverlayIndex + 1);
            }

            lShownOverlay = mKeyLayer.showOverlay(mOverlayIndex);
            lShownOverlay.icon.url = mTrackIcon;


            if (!mThis.isNothing(mSpeedProperty)) {
                lMultiplier = mSpeedMultipliers[lShownOverlay.sumoData[mSpeedProperty]];
                if (lMultiplier !== mCurrentMultiplier) {
                    stopTimer();
                    mCurrentMultiplier = lMultiplier;
                    mInterval = (mInitialInterval / mSpeedDivider) * mCurrentMultiplier;

                    if (mState === PLAYING) {
                        startTimer();
                    }
                }
            }
            mOverlaysVisible.push(mOverlayIndex);

            iterateShowOverlay();
            mKeyLayer.panToOverlay(mOverlayIndex);

            if ((mDirection === 1 && mOverlayIndex >= mItemsToShow) ||
                (mDirection === -1 && mOverlayIndex <= (mOverlayCount - mItemsToShow))) {
                iterateHideOverlay();
                mKeyLayer.hideOverlay(mOverlayIndex - (mDirection * mItemsToShow));
            }
            mBookmarkPercentage = (mOverlayIndex * 100) / mOverlayCount;
            mCurrentPoint = lShownOverlay.sumoData;
            mThis.trigger('progressed', {
                'currentPoint': lShownOverlay.sumoData,
                'currentIndex': mOverlayIndex,
                'overlayCount': mOverlayCount,
                'progressPercentage':mBookmarkPercentage
            });
            if(mIsActive){
                mOverlaysPlayed +=1;
            }
            
            const selectedBookmarkIndex = mOverlayIndex;
            let lSelectedBookmark = mBookmarksHashMap.get(selectedBookmarkIndex);
            if (mBookmarksHashMap.has(selectedBookmarkIndex)&& !lSelectedBookmark.viewed && mState == PLAYING) {
                lSelectedBookmark.viewed = mIsActive;
                mThis.trigger('bookmark_viewed', {
                    'currentBookmark': lSelectedBookmark,
                    'bookmarkIndex': mOverlayIndex,
                    'progressPercentage':mBookmarkPercentage
                    });
                mBookmarksHashMap.set(selectedBookmarkIndex, lSelectedBookmark);
                if(mIsActive){
                    $(`.ui-bookmark-container div[p="${selectedBookmarkIndex}"]`).addClass('watched-bookmark');
                    if(mBookmarksAutoPause){
                        mThis.pause();
                        $(`.ui-bookmark-container div[p="${selectedBookmarkIndex}"]`).addClass("tool-tip-show");
                    }
                }
                
            }           
        } else {
            // playback is complete
            stopTimer();
            setState(STOPPED);

            window.setTimeout(window_OnTimer, mInitialInterval);
        }
        correctOverlayVisibility();
    }

    this.IsActive = function () {
        return mIsActive;
    }
    this.Activate = function (aActiveFlag) {
        mIsActive = aActiveFlag;
    }
    this.pause = function () {
        stopTimer();
        setState(PAUSED);
    };

    this.start = function () {
        if (mState !== PAUSED) {
            if (mState === STOPPED) {
                reInitialize();
            }
            mKeyLayer.hide();
            iterateSupportLayers('hide', null);
        }
        if(mState == PAUSED){
            this.tooltipHide();
        }
        setState(PLAYING);
        
        startTimer();
    };

    this.stop = function () {
        var lFixOverlay;

        stopTimer();
        if (mDirection == -1 && mOverlayIndex == 0) {

        }
        setState(STOPPED);
        mOverlayIndex = -1; // YES, minus one
        mKeyLayer.fixOverLay();
        mKeyLayer.show();
        iterateResetVisiblity();
        mOverlayCount = 0;
        mOverlaysPlayed =0;
        this.tooltipHide();
    };

    this.speed = function (aValue) {
        var lResult = null;
        if (this.isNothing(aValue)) {
            lResult = mSpeedDivider;
        } else {
            if (aValue !== mSpeedDivider) {
                if (mState === PLAYING) {
                    stopTimer();
                }
                mSpeedDivider = aValue;
                //mInterval = mInitialInterval / mSpeedDivider;
                mInterval = (mInitialInterval / mSpeedDivider) * mCurrentMultiplier;
                if (mState === PLAYING) {
                    startTimer();
                }
            }
        }
        return lResult;
    };

    this.direction = function (aValue) {
        var lResult = null;
        if (this.isNothing(aValue)) {
            lResult = mDirection;
        } else {
            if (aValue !== mDirection) {
                mDirection = aValue;
                mOverlayIndex += (mDirection * (mItemsToShow - 1));
            }
        }
        return lResult;
    };
    this.tooltipHide = function(){
        $('.tool-tip').removeClass('tool-tip-show');
    };
    this.getCurrentIndex = function(){
        return mOverlayIndex;
    }
    this.getOverlayCount = function () {
        return mKeyLayer.overlays().length;
    };
    this.getCurrentPoint = function(){
        return mCurrentPoint;
    }

    this.getOverlaysPlayed = function(){
        return mOverlaysPlayed;
    }

    this.setIndex = function (aIndex, aSliding) {
        if (mOverlayIndex === -1) {
            if (mState === STOPPED) {
                reInitialize();
                mKeyLayer.hide();
                iterateSupportLayers('hide', null);
            }
        }
        
        if (mState !== PLAYING) {
            if (aIndex < mOverlayIndex) {
                mThis.direction(-1);
            } else {
                mThis.direction(1);
            }
        } else {
            mKeyLayer.hide();
        }
        mOverlayIndex = aIndex;
        
        

        if (!isNullOrUndefined(aSliding)) {
            if (aSliding) {
                FixDirection(mDirection, aIndex);
            }
        }
        updateOverlays();
    };

    function FixDirection(aDirection, aIndex) {
        var count;
        if (aDirection == 1) {
            count = aIndex - mItemsToShow;
        } else {
            count = aIndex + mItemsToShow;
        }

        for (count; count < aIndex; count++) {
            if (count >= 0) {
                var lOverlay = mKeyLayer.showOverlay(count);
                lOverlay.icon.url = mKeyLayer.getMarkerOverlay(count);
            }
        }


    }

    this.next = function () {
        if (mOverlayIndex < mOverlayCount) {
            if (mState === STOPPED) {
                reInitialize();
                mKeyLayer.hide();
                iterateSupportLayers('hide', null);
                mThis.pause();
            }

            mThis.setIndex(mOverlayIndex + 1);
            this.tooltipHide();
        }
    };

    this.previous = function () {
        if (mOverlayIndex > 0) {
            if (mState === STOPPED) {
                reInitialize();
                mKeyLayer.hide();
                iterateSupportLayers('hide', null);
                mThis.pause();
            }
            mThis.setIndex(mOverlayIndex - 1);
            this.tooltipHide();
        }
    };

    this.dispose = function () {
        stopTimer();
        this.removeBookmarks();
        sumo.maps.Playback.prototype.dispose.call(this);
    };
    /**
     * Bookmark Wrapper that returns an HTMLElement tooltip
     * @param {string} aName 
     * @param {number} aIndex 
     * @param {number} aPosition 
     * @param {number} aPercentage 
     * @param {Object} aSumoData 
     * @param {string} aHTMLTemplate 
     * @returns HTMLElement 
     */
    function createBookmarkNode(aName,aIndex,aPosition,aPercentage,aSumoData,aHTMLTemplate) {
        const node = document.createElement('div');
        node.id = `b${aSumoData.Id}`;// based on given data we construct our ID TODO: Change it .
        node.setAttribute("i", aIndex);
        node.setAttribute("p", aPosition);
        node.style="left:"+aPercentage+"%;";
        node.className = "tool-tip "+mBookmarkClass+" bookmark_"+aName+"";
        node.innerHTML = `<div class="tool-tip-text">${aHTMLTemplate}</div>`;
        return node;
    } 
    /**
     * Set Bookmark Layer data 
     * @param {string} aName 
     * @param {object} aBookmarksData 
     */
    this.setDataBookmarks = function (aName,aBookmarksData) {
        if (!mThis.isNothing(aName)) {
            mBookmarksData[aName] = aBookmarksData;
        }
    };
    /**
     * Render Bookmark Layer with given HTML Tooltip Formatter
     * @param {string} aName 
     * @param {function} aBookmarkFormatter Function that passes the Bookmark Data and should return a string 
     */
    function render_bookmarks(aName,aBookmarkFormatter){
        const lDates = mBookmarksDateRange ? mBookmarksDateRange() : null;
        const bookmark = mBookmarksData[aName];
        const MAX_PERCENTAGE_RAGE = 99;
        const lOverlayCount = mKeyLayer.overlays().length - 1; // Overlay Size 
        const lStepSize = (MAX_PERCENTAGE_RAGE / lOverlayCount); // Bookmark StepSize 
        const slider = document.getElementById(mSliderId);
        for (var key in bookmark) {
            if (bookmark.hasOwnProperty(key)) {
                const startDate = new Date(bookmark[key]['StartDateUTC']);
                const calculatedPercentageProgress =  Math.abs(Math.round(((startDate - lDates.startDate) / (lDates.endDate - lDates.startDate)) * MAX_PERCENTAGE_RAGE));
                const progressStep =  Math.floor( calculatedPercentageProgress / lStepSize );
                const bookmarkPositionPercentage  = ( lStepSize * progressStep ) ;
                if (mBookmarksHashMap.has(progressStep)) {
                    const lSelectedBookmark = mBookmarksHashMap.get(progressStep);
                    lSelectedBookmark.data.push(bookmark[key]);
                    mBookmarksHashMap.set(progressStep, lSelectedBookmark);
                    const node = document.querySelector(`[p="${progressStep}"] > div`);
                    if(!mThis.isNothing(node)){
                        const wrapperDiv = document.createElement('div');
                        wrapperDiv.style= "display:inline-block;margin-bottom:5px";
                        wrapperDiv.innerHTML=aBookmarkFormatter(bookmark[key]);
                        node.appendChild(wrapperDiv);
                    }
                    //
                } else {
                    mBookmarksHashMap.set(progressStep,{
                        position: progressStep,
                        percentage:bookmarkPositionPercentage,
                        viewed:false,
                        data:[bookmark[key]]
                    });
                    const wrapperDiv = document.createElement('div');
                    wrapperDiv.style= "display:inline-block;margin-bottom:5px";
                    wrapperDiv.innerHTML=aBookmarkFormatter(bookmark[key]);
                    slider.appendChild(createBookmarkNode(aName,key,progressStep,bookmarkPositionPercentage, bookmark[key],wrapperDiv.outerHTML));
                }
            }
        }
    }
    /**
     * Remove bookmarks 
     */
    this.removeBookmarks = function () {
        $("." + mBookmarkClass).remove();
        mBookmarksHashMap = new Map();
    }

    /**
     * Renders a bookmark based on Layer data. 
     * Requires setDataBookmarks@ function  
     * @param {string} aBookmarkName Bookmark Layer name 
     * @param {function} aBookmarkFormatter Function that passes the Bookmark Data and should return a string
     */
    this.bookmarkAdd =function(aBookmarkName, aBookmarkFormatter){
        render_bookmarks(aBookmarkName,aBookmarkFormatter);
    }

    /* ---------------------------------------------------------------------------------------------------- */
    function keyLayer_OnDataBind(aSender, aData, aParams) {
        var lBuilder = new SumoPredicateBuilder(),
            lKeyDataSource,
            //lKeyTrackItem,
            lKeyTrackKey,
            lSupportDataSource,
            lSupportItem,
            lSupportKey,
            lSupportName,
            //lSupportTrackItems,
            lQuery,

            lStartTime,
            lEndTime,
            lItem,
            i;
        lKeyDataSource = mKeyLayer.overlays();
        for (lKeyTrackKey in lKeyDataSource) {
            if (lKeyDataSource.hasOwnProperty(lKeyTrackKey)) {
                //lKeyTrackItem = lKeyDataSource[lKeyTrackKey];
                lStartTime = null;
                lEndTime = null;
                // find trackpoints within the display count (left)
                for (i = lKeyTrackKey - mItemsToShow; i <= lKeyTrackKey; ++i) {
                    lItem = lKeyDataSource[i];
                    if (!mThis.isNothing(lItem) && !mThis.isNothing(lItem[mIdentityProperty])) {
                        if (mThis.isNothing(lStartTime) || lStartTime > lItem[mIdentityProperty]) {
                            lStartTime = lItem[mIdentityProperty];
                        }
                        if (mThis.isNothing(lEndTime) || lEndTime < lItem[mIdentityProperty]) {
                            lEndTime = lItem[mIdentityProperty];
                        }
                    }
                }

                // get their overall data range
                lBuilder.AddNewExpressionConditional(mIdentityProperty, lStartTime, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional(mIdentityProperty, lEndTime, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

                // loop through support layers
                for (lSupportKey in mSupportLayers) {
                    if (mSupportLayers.hasOwnProperty(lSupportKey)) {
                        lSupportItem = mSupportLayers[lSupportKey];
                        lSupportDataSource = lSupportItem.overlays();
                        lSupportName = lSupportItem.name();

                        // query source within range
                        lQuery = query(lSupportDataSource, lBuilder.RootExpression);

                        // add to hash based on lKeyTrackKey
                        if (mThis.isNothing(mSupportHash[lSupportName])) {
                            mSupportHash[lSupportName] = [];
                        }
                        mSupportHash[lSupportName][lKeyTrackKey] = lQuery;
                    }
                }
                lBuilder.Clear();
            }
        }
    }

    function supportLayer_OnDataBind(aSender, aData, aParams) {
        var lBuilder = new SumoPredicateBuilder(),
            lKeyDataSource,
            //lKeyTrackItem,
            lKeyTrackKey,
            lSupportDataSource,
            //lSupportItem,
            //lSupportKey,
            lSupportName,
            //lSupportTrackItems,
            lQuery,

            lStartTime,
            lEndTime,
            lItem,
            i;

        lKeyDataSource = mKeyLayer.overlays();
        lSupportName = aSender.name();
        lSupportDataSource = aSender.overlays();
        mSupportHash[lSupportName] = [];
        for (lKeyTrackKey in lKeyDataSource) {
            if (lKeyDataSource.hasOwnProperty(lKeyTrackKey)) {
                //lKeyTrackItem = lKeyDataSource[lKeyTrackKey];
                lStartTime = null;
                lEndTime = null;
                // find trackpoints within the display count (left)
                for (i = lKeyTrackKey - mItemsToShow; i <= lKeyTrackKey; ++i) {
                    lItem = lKeyDataSource[i];
                    if (!mThis.isNothing(lItem) && !mThis.isNothing(lItem[mIdentityProperty])) {
                        if (mThis.isNothing(lStartTime) || lStartTime > lItem[mIdentityProperty]) {
                            lStartTime = lItem[mIdentityProperty];
                        }
                        if (mThis.isNothing(lEndTime) || lEndTime < lItem[mIdentityProperty]) {
                            lEndTime = lItem[mIdentityProperty];
                        }
                    }
                }

                // get their overall data range
                lBuilder.AddNewExpressionConditional(mIdentityProperty, lStartTime, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional(mIdentityProperty, lEndTime, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

                // query source within range
                lQuery = query(lSupportDataSource, lBuilder.RootExpression);

                // add to hash based on lKeyTrackKey
                //if (lQuery.length > 0) {
                //    var l = '';
                //}
                mSupportHash[lSupportName][lKeyTrackKey] = lQuery;

                lBuilder.Clear();
            }
        }
    }
    /* ---------------------------------------------------------------------------------------------------- */

    function initialize() {
        var lItem,
            lKey;
        aKeyLayer.bind('databind', keyLayer_OnDataBind);
        if (!mThis.isNothing(aSupportLayers)) {
            for (lKey in aSupportLayers) {
                if (aSupportLayers.hasOwnProperty(lKey)) {
                    lItem = aSupportLayers[lKey];
                    lItem.bind('databind', supportLayer_OnDataBind);
                }
            }
        }
        if (!mThis.isNothing(aOptions)) {
            if (!mThis.isNothing(aOptions.displayCount)) {
                mItemsToShow = aOptions.displayCount;
            }
            if (!mThis.isNothing(aOptions.initialInterval)) {
                mInitialInterval = aOptions.initialInterval;
            }
            if (!mThis.isNothing(aOptions.speedControls)) {
                mSpeedProperty = aOptions.speedControls.keyProperty;

                for (lKey in aOptions.speedControls.values) {
                    if (aOptions.speedControls.values.hasOwnProperty(lKey)) {
                        lItem = aOptions.speedControls.values[lKey];
                        mSpeedMultipliers[lItem.value] = lItem.speedMultiplier;
                    }
                }

            }
            if (!mThis.isNothing(aOptions.identityProperty)) {
                mIdentityProperty = aOptions.identityProperty;
            }

            if (!mThis.isNothing(aOptions.sliderId)) {
                mSliderId = aOptions.sliderId;
            }
            if (!mThis.isNothing(aOptions.bookmarks)) {
                if (!mThis.isNothing(aOptions.bookmarks.bookmarkClass)) {
                    mBookmarkClass = aOptions.bookmarks.bookmarkClass;
                }
                if (!mThis.isNothing(aOptions.bookmarks.filterByMethod)) {
                    mBookmarksFilterMethod = aOptions.bookmarks.filterByMethod;
                }
                if (!mThis.isNothing(aOptions.bookmarks.formatMethod)) {
                    mBookmarksFormatMethod = aOptions.bookmarks.formatMethod;
                }
                if (!mThis.isNothing(aOptions.bookmarks.dateRange)) {
                    mBookmarksDateRange = aOptions.bookmarks.dateRange;
                }
                if (!mThis.isNothing(aOptions.bookmarks.tooltipTemplate)) {
                    mBookmarksHtmlTemplate = aOptions.bookmarks.tooltipTemplate;
                }
                if (!mThis.isNothing(aOptions.bookmarks.autoPause)) {
                    mBookmarksAutoPause = aOptions.bookmarks.autoPause;
                }
            }
        }
    }

    initialize();

};
sumo.maps.Playback.prototype = new sumo.Class();
sumo.maps.Playback.prototype.constructor = sumo.maps.Playback;
sumo.maps.Playback.prototype.baseClass = sumo.Class;